<div class="redirect-container">
  <div class="redirect-content">
      <h1>Einen Moment Geduld...</h1>
      <p>Sie werden gleich weitergeleitet.</p>
      <div class="spinner"></div>
  </div>
</div>